var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Toast } from 'ngx-toastr';
var ToastrComponent = /** @class */ (function (_super) {
    __extends(ToastrComponent, _super);
    function ToastrComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ToastrComponent.prototype.ngOnInit = function () { };
    ToastrComponent.prototype.action = function (event) {
        event.stopPropagation();
        this.toastPackage.triggerAction();
        return false;
    };
    return ToastrComponent;
}(Toast));
export { ToastrComponent };
